import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-modal';
// import { useNavigate } from 'react-router-dom';
import "./NoAcess.css";


Modal.setAppElement('#root');

function NoAcess() {
    const visorRef = useRef(null);
    const cordRef = useRef(null);
    // const navigate = useNavigate();

    useEffect(() => {
        const visorCanvas = visorRef.current;
        const visorCtx = visorCanvas.getContext('2d');
        visorCtx.fillStyle = 'gray';
        visorCtx.beginPath();
        visorCtx.arc(visorCanvas.width / 2, visorCanvas.height / 2, visorCanvas.width / 2, 0, Math.PI * 2);
        visorCtx.fill();
    }, []);

    // const handleLogout = () => {
    //     localStorage.removeItem('token');
    //     localStorage.removeItem('userId');
    //     localStorage.removeItem('username');
    //     localStorage.removeItem('nome_completo');
    //     navigate('/');
    // };

    // const handleHome = () => {
    //     navigate('/home');
    // };

    return (
        <div className="fundo-404">
            <div class="moon"></div>
            <div class="moon__crater moon__crater1"></div>
            <div class="moon__crater moon__crater2"></div>
            <div class="moon__crater moon__crater3"></div>

            <div class="star star1"></div>
            <div class="star star2"></div>
            <div class="star star3"></div>
            <div class="star star4"></div>
            <div class="star star5"></div>

            <div class="error">
                <div class="error__title">404</div>
                <div class="error__subtitle">Hmmm...</div>
                <div class="error__description">A página solicitada não foi encontrada ou <br></br>você não tem permissão para acessá-la.</div>
                {/* <button onClick={handleHome} class="error__button error__button--active">HOME</button>
                <button onClick={handleLogout} class="error__button">LOGOUT</button> */}
            </div>

            <div class="astronaut">
                <div class="astronaut__backpack"></div>
                <div class="astronaut__body"></div>
                <div class="astronaut__body__chest"></div>
                <div class="astronaut__arm-left1"></div>
                <div class="astronaut__arm-left2"></div>
                <div class="astronaut__arm-right1"></div>
                <div class="astronaut__arm-right2"></div>
                <div class="astronaut__arm-thumb-left"></div>
                <div class="astronaut__arm-thumb-right"></div>
                <div class="astronaut__leg-left"></div>
                <div class="astronaut__leg-right"></div>
                <div class="astronaut__foot-left"></div>
                <div class="astronaut__foot-right"></div>
                <div class="astronaut__wrist-left"></div>
                <div class="astronaut__wrist-right"></div>

                <div class="astronaut__cord">
                    <canvas id="cord" height="500px" width="500px" ref={cordRef}></canvas>
                </div>

                <div class="astronaut__head">
                    <canvas id="visor" width="60px" height="60px" ref={visorRef}></canvas>
                    <div class="astronaut__head-visor-flare1"></div>
                    <div class="astronaut__head-visor-flare2"></div>
                </div>
            </div>
        </div>
    );
}

export default NoAcess;